import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import { ImageUrl } from '../../../../../Helpers/request'
import { LazyLoadImage } from "react-lazy-load-image-component";

let categoryData=[
    {
        img: `${ImageUrl}theme/macau/bracelet.jpg`,
        title: "Bracelets",
        link: "#"
    },
    {
        img: `${ImageUrl}theme/macau/earrings.jpg`,
        title: "Earrings",
        link: "#"
    },
    {
        img: `${ImageUrl}theme/macau/pendant.jpg`,
        title: "Pendants",
        link: "#"
    }
]
const MacauCategory = () => {
  return (
    <div className='pt80 ptMob30'>
    <Container className='containerV1'>
    <Row className='gy-4'>
      {
        categoryData.map((e,i)=>(
        <Col className='mb-3' lg={4} md={4} key={i}>
        <div className="box_img position-relative overflow-hidden">
                <div className="picture overflow-hidden">
                    <Link to="/jewelry/bracelets">
                        <LazyLoadImage src={e?.img} className="img-fluid transition " alt="Bracelets"/>
                    </Link>
                </div>
                <div className="info">
                    <h3 className="title fontMessiri">{e.title}</h3>
                    <div className="buttonLink"> <a href="/jewelry/bracelets" className="button-banner text-dark">Shop now</a>
                    </div>
                </div>
            </div>
        </Col>
        ))
      }
      
      </Row>
    </Container>

    </div>
  )
}

export default MacauCategory
